import { usingGet, usingPost } from '@ocean/api'
import { UserUtils } from 'utils'
import { RapidElearningProgressUpdateDto } from 'modules/activityDetails/RapidElearningDetails/types'

export const getRapidElearningDetails = (rapidElearningId: Guid) =>
  usingGet(`rapidelearning/details/${rapidElearningId}`, { useProxy: true })

export const createRapidElearningResult = (courseId: Guid) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingPost(`RapidElearnings/CreateRapidElearningResult`, {
    courseId,
    userId,
  })
}

export const startRapidElearningAttempt = (activityResultId: Guid) =>
  usingPost('RapidElearnings/StartRapidElearningAttempt', {
    activityResultId,
  })

export const updateRapidElearningAttempt = (progressUpdateDto: RapidElearningProgressUpdateDto) =>
  usingPost(`RapidElearnings/UpdateRapidElearningAttempt`, progressUpdateDto)

export const closeRapidElearningResult = (resultId: Guid) =>
  usingPost(`RapidElearnings/CloseRapidElearningResult`, { resultId })
